/**
 * Alatreyu - Notify Me When Available (inline)
 *
 * Inline back-in-stock email capture shown only on genuinely sold-out products
 * (product.available == false). POSTs to the storefront API, which stores the
 * request and fires exactly one email when the scent returns. Does NOT subscribe
 * the shopper to any marketing list. On success the button becomes "Success!"
 * and stays pressed. Dependency-free vanilla JS.
 *
 * ONE card serves BOTH formats. The PDP renders a single card for the product
 * the page loaded with, but the format switcher (candle <-> wax melts) swaps
 * products in place without a reload. Exposes window.AlatreyuNotify.setProduct()
 * so the switcher can re-point the card at the format now on screen. Signup
 * state is tracked per SKU, so the candle and the wax melts are independent:
 * signing up for one leaves the other's form open, and switching back to a
 * format already signed up for restores its "Success!" state instead of
 * inviting a duplicate submission.
 */
(function () {
  'use strict';

  var API_URL = 'https://front.4147r3yu.com/api/notify';
  var renderedAt = Date.now();

  var card = document.querySelector('.pwyc-notify');
  if (!card) return;

  var form = card.querySelector('.pwyc-notify__form');
  var emailInput = card.querySelector('.pwyc-notify__input');
  var hpInput = card.querySelector('[name="website"]');
  var errorEl = card.querySelector('.pwyc-notify__error');
  var submitBtn = card.querySelector('.pwyc-notify__btn');
  var noteTitleEl = card.querySelector('.pwyc-notify__note-title');
  var noteVerbEl = card.querySelector('.pwyc-notify__note-verb');

  var IDLE_LABEL = submitBtn.textContent;

  // Which SKUs this shopper has already signed up for, this page view.
  // Keyed by SKU so candle and wax melts never share a success state.
  var signedUp = {};

  function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
  function hideError() { errorEl.textContent = ''; errorEl.hidden = true; }
  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  // "Wax Melts" is plural: "... are back in stock". Everything else is
  // singular. Mirrors the notify_verb assign in alatreyu-product.liquid.
  function formatVerb(sku) { return /^WM-/i.test(sku || '') ? 'are' : 'is'; }

  function getContext() {
    return {
      sku: card.getAttribute('data-sku') || '',
      handle: card.getAttribute('data-handle') || '',
      product_id: card.getAttribute('data-product-id') || ''
    };
  }

  // Render the form for whichever SKU the card currently points at:
  // pressed "Success!" if already signed up, otherwise open for input.
  // The typed email is deliberately preserved across format switches.
  function applyState() {
    if (signedUp[getContext().sku]) {
      submitBtn.textContent = 'Success!';
      submitBtn.disabled = true;
      submitBtn.classList.add('is-success');
      emailInput.disabled = true;
    } else {
      submitBtn.textContent = IDLE_LABEL;
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-success');
      emailInput.disabled = false;
    }
  }

  // Terminal success state for the CURRENT sku: button reads "Success!".
  function succeed() {
    signedUp[getContext().sku] = true;
    applyState();
  }

  /**
   * Re-point the card at another product (format switcher, no reload).
   * Without this the card keeps the landing product's SKU, and a shopper
   * waiting on a sold-out wax melt is recorded against the in-stock candle.
   */
  function setProduct(info) {
    if (!info) return;
    if (info.sku !== undefined) card.setAttribute('data-sku', info.sku || '');
    if (info.handle !== undefined) card.setAttribute('data-handle', info.handle || '');
    if (info.productId !== undefined) {
      card.setAttribute('data-product-id', info.productId == null ? '' : String(info.productId));
    }
    if (info.title && noteTitleEl) noteTitleEl.textContent = info.title;
    if (info.sku !== undefined && noteVerbEl) noteVerbEl.textContent = formatVerb(info.sku);
    hideError();
    applyState();
  }

  window.AlatreyuNotify = { setProduct: setProduct };

  // Pre-fill for logged-in customers.
  if (window.alatreyuCustomerEmail && !emailInput.value) {
    emailInput.value = window.alatreyuCustomerEmail;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hideError();

    // Honeypot tripped: show success without hitting the API.
    if (hpInput && hpInput.value.trim() !== '') { succeed(); return; }

    var email = emailInput.value.trim();
    if (!email || !isValidEmail(email)) {
      showError('Please enter a valid email address.');
      emailInput.focus();
      return;
    }

    // Snapshot the target: a format switch mid-flight must not let the
    // response land against the product now on screen.
    var ctx = getContext();
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email, sku: ctx.sku, handle: ctx.handle,
        product_id: ctx.product_id, rendered_at: renderedAt,
        website: hpInput ? hpInput.value : ''
      })
    })
      .then(function (res) {
        if (res.status === 429) {
          throw new Error('You have made a few requests in a row. Please wait a moment and try again.');
        }
        return res.json();
      })
      .then(function (data) {
        if (data && data.success) {
          // Credit the SKU that was submitted, not whatever is on screen now.
          signedUp[ctx.sku] = true;
          applyState();
        } else {
          applyState();
          showError((data && data.error) || 'Something went wrong. Please try again.');
        }
      })
      .catch(function (err) {
        applyState();
        showError(err.message || 'Something went wrong. Please try again.');
      });
  });
})();
